import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=4820c98a&scoped=true"
import script from "./Catalogue.vue?vue&type=script&lang=js"
export * from "./Catalogue.vue?vue&type=script&lang=js"
import style0 from "./Catalogue.vue?vue&type=style&index=0&id=4820c98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820c98a",
  null
  
)

export default component.exports